import ChangePwd from 'pages/ChangePwd'
import HomeAgent from 'pages/HomeAgent'
import MyQrCode from 'pages/MyQrCode/MyQrCode'
import Notifications from 'pages/notification/Notifications'
import Refund from 'pages/refund/Refund'
import TransactionManager from 'pages/transaction_manager/TransactionManager'
import SharedLayout from 'utils/SharedLayout'
import { HomeRedirect } from './HomeRedirect'

const AgentRoutes = {
  // All common routes
  path: '/',
  element: <SharedLayout />,
  children: [
    {
      path: '/dashboard-agent',
      element: <HomeAgent />
    },
    {
      path: '/my-transactions',
      element: <TransactionManager />
    },
    {
      path: '/refund',
      element: <Refund />
    },
    {
      path: '/change_pwd',
      element: <ChangePwd />
    },
    {
      path: '/notifications',
      element: <Notifications />
    },
    {
      path: '/my-qrcode',
      element: <MyQrCode />
    },
    {
      path: '*',
      element: <HomeRedirect to='/dashboard-agent' />
    }
  ]
}

export default AgentRoutes
